/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { getRequest, postRequest } from "utils/request";
import Chat from "components/Chat";
import MaskedInput from "react-maskedinput";
import socketIOClient from "socket.io-client";
import { i18n } from "../../translate/i18n";
import "./style.css";
import { getRandomValue } from "utils/random";
import { isProductionEnvironment } from "utils/network";

function ClientChat({ match }) {
  const [configs, setConfigs] = useState({});
  const [ticket, setTicket] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingContainer, setLoadingContainer] = useState(false);
  const [user, setUser] = useState({
    name: "",
    tel: "",
    email: "",
  });

  useEffect(() => {
    // setLoading(true);
    getConfigs(match.params.token);
    // setLoading(false);
  }, []);

  async function getConfigs(token) {
    setLoading(true);
    getRequest(`/chat/settings?company=${token}`).then((resp) => {
      setConfigs(resp.data);
      setLoading(false);
    });
  }

  async function handleSubmitChat(e) {
    e.preventDefault();
    if (match?.params?.token) {
      setLoadingContainer(true);

      const ReturnPost = await postRequest(`/chat`, {
        company: match.params.token,
        name: user.name,
        cellPhone: user.tel,
        email: user.email,
      });
      if (ReturnPost.success) {
        setTicket(ReturnPost.data);

        //INICIA O SOCKET
        //TODO colocar no context de socket função que cria e retorna socket Do cliente
        const socket = socketIOClient(process.env.REACT_APP_API_URL_SOCKET, {
          query: { userId: ReturnPost.data.CustomerId, customer: true },
        });

        socket.on("notification", async (data) => {
          if (data) {
            setTicket(data);
          }
        });
      }
    }
    setLoadingContainer(false);
  }

  const handleLogout = () => {
    setLoading(true);
    // putRequest(`/chat/close/${ticket.id}`).finally(() => {
    setTimeout(() => {
      setUser({
        name: "",
        tel: "",
        email: "",
      });
      setTicket("");
      setLoading(false);
    }, 1000);
    // })
  };

  const ConfigMask = (data) => {
    let value;

    value = data.replace(/([^\d])+/gim, "");
    return value;
  };

  const postRandomTicket = async () => {
    setUser({
      name: getRandomValue("name"),
      tel: getRandomValue("phone"),
      email: getRandomValue("email"),
    });
  };

  useEffect(() => {
    if (document.location.hostname === "localhost") {
      document.title = "LOCAL customer chat";
    }
  }, []);

  return !loading ? (
    <div
      className="container-client-chat"
      style={{ backgroundColor: configs.backgroundColorChat }}
    >
      <>
        <header
          className="header-client-chat"
          style={{ backgroundColor: configs.defaultColor }}
        >
          <div className="box-left-client-chat">
            <img src={configs.logo} alt="logo" />
            <span>{i18n.t("howCanHelp")}</span>
          </div>
          {ticket !== "" && (
            <button
              type="button"
              className="btn btn-danger"
              style={{ marginLeft: 0 }}
              onClick={() => handleLogout()}
            >
              <i className="uil uil-exit" style={{ fontSize: 17 }}></i>
            </button>
          )}
        </header>
        {ticket === "" ? (
          <div className="contain-client-chat">
            {!loadingContainer ? (
              <>
                <div className="contain-title-area-client-chat">
                  <span>{i18n.t("infoToStart")}</span>
                </div>
                <form onSubmit={handleSubmitChat}>
                  {!isProductionEnvironment() && (
                    <button
                      type="button"
                      onClick={postRandomTicket}
                      className="btn btn-warning"
                    >
                      Gerar valores aleatórios
                    </button>
                  )}
                  <input
                    required
                    placeholder={i18n.t("name") + " *"}
                    value={user.name}
                    onChange={(value) =>
                      setUser((prevState) => {
                        return { ...prevState, name: value.target.value };
                      })
                    }
                    style={{
                      borderColor: configs.backgroundColorCompanyAnswer,
                    }}
                  />
                  <MaskedInput
                    mask="+11 (11) 11111-1111"
                    required
                    placeholder="+99 (99) 99999-9999 *"
                    value={user.tel}
                    onChange={(value) =>
                      setUser((prevState) => {
                        return {
                          ...prevState,
                          tel: ConfigMask(value.target.value),
                        };
                      })
                    }
                    style={{
                      borderColor: configs.backgroundColorCompanyAnswer,
                    }}
                  />
                  <input
                    required
                    type="email"
                    placeholder="seuemail@email.com *"
                    value={user.email}
                    onChange={(value) =>
                      setUser((prevState) => {
                        return { ...prevState, email: value.target.value };
                      })
                    }
                    style={{
                      borderColor: configs.backgroundColorCompanyAnswer,
                    }}
                  />
                  <button
                    type="submit"
                    style={{
                      backgroundColor: configs.defaultColor,
                      marginColor: configs.defaultColor,
                    }}
                  >
                    {i18n.t("start")}
                  </button>
                </form>
              </>
            ) : (
              <CircularProgress />
            )}
          </div>
        ) : (
          <Chat FullTicket={ticket} colors={configs} />
        )}
      </>
    </div>
  ) : (
    <div className="area-loading-client-chat" style={{ height: "100vh" }}>
      <CircularProgress />
    </div>
  );
}

export default ClientChat;
